import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { ToastService } from '../../../services/toast.service';
import { MapLayerConfiguration } from '../../../models/map-layer.model';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MainRoute, RootRoute, SettingsRoute } from '../../../models/angular-routing';
import { BaseMapType, SettingsService } from '../../../../configuration/settings.service';
import { SecurityService } from '../../../../security/security.service';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-layers-visibility-settings',
  imports: [
    MatIcon,
    MatDivider,
    MatSlideToggle,
    MatTooltip,
    MatIconButton,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
  ],
  templateUrl: './custom-layers-visibility-settings.component.html',
  styleUrl: './custom-layers-visibility-settings.component.scss',
})
export class CustomLayersVisibilitySettingsComponent implements OnInit {
  mapLayers: MapLayerConfiguration[];
  visibleLayerIdMap = new Map<number, boolean>();
  hasMapSettingsAccess$: Observable<boolean>;

  protected readonly RootRoute = RootRoute;
  protected readonly MainRoute = MainRoute;
  protected readonly SettingsRoute = SettingsRoute;

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly settingsService: SettingsService,
    private readonly securityService: SecurityService,
    private router: Router,
    private readonly dialogRef: MatDialogRef<any>,
    private readonly toast: ToastService
  ) {}

  ngOnInit() {
    this.hasMapSettingsAccess$ = this.securityService.hasPermission(SettingsRoute.MAP_SETTINGS);

    this.configurationService
      .getAllMapLayers()
      .then(layers => {
        this.mapLayers = layers;

        const visibleLayersFromSettings = this.settingsService.getStringValue(SettingsService.VISIBLE_CUSTOM_MAP_LAYERS);
        if (visibleLayersFromSettings && visibleLayersFromSettings.length > 0) {
          visibleLayersFromSettings
            .split(':::')
            .map(layerId => +layerId)
            .forEach(layerId => this.visibleLayerIdMap.set(layerId, true));
        }
      })
      .catch(error => {
        const msg = 'Error while loading map layer configurations';
        console.error(msg, error);
        this.toast.long(msg);
        throw Error(error);
      });
  }

  onToggleChange(mapLayer: MapLayerConfiguration, event: MatSlideToggleChange) {
    this.visibleLayerIdMap.set(mapLayer.id, event.checked);
    this.settingsService.setStringValue(
      SettingsService.VISIBLE_CUSTOM_MAP_LAYERS,
      [...this.visibleLayerIdMap.entries()]
        .filter(([_, visible]) => visible)
        .map(([id]) => id)
        .join(':::')
    );
    // when toggled off, disable layer visibility settings too
    if (!event.checked && !mapLayer.useAsBaseMap) {
      this.settingsService.setBooleanValue(mapLayer.name, false);
    } else if (!event.checked && mapLayer.useAsBaseMap) {
      this.settingsService.setStringValue(SettingsService.BASE_MAP_LAYER_KEY, BaseMapType.WINTER);
    }
  }

  goToMapSettings() {
    this.dialogRef.close();
    this.router.navigate(['/', RootRoute.SETTINGS, SettingsRoute.MAP_SETTINGS]).then();
  }
}
